import * as filterActions from '../actions/current-filter.actions';

export const initialState: any = {};

export function reducer(state: any = initialState, action: filterActions.CurrentFiltersAction): any {
  switch (action.type) {
    case filterActions.UPDATE_CURRENT_FILTERS_SUCCESS: {
      return {
        ...action.payload,
      };
    }
    case filterActions.GET_CURRENT_FILTERS_SUCCESS: {
      return {
        ...action.payload,
      };
    }
    case filterActions.CLEAR_CURRENT_FILTERS: {
      return {};
    }
    default:
      return state;
  }
}
